import React from 'react';

export default function WorkspaceNotice({
  title,
  message,
  detail,
  actionLabel,
  onAction,
  testId,
}) {
  return (
    <section
      data-testid={testId}
      className="border border-red-200 bg-red-50 p-6 text-red-800"
    >
      <p className="text-xs font-mono uppercase tracking-widest text-red-500">
        Workspace access
      </p>
      <h2 className="mt-1 font-display text-2xl font-bold tracking-tight text-red-950">
        {title}
      </h2>
      <p className="mt-3 max-w-2xl text-sm leading-6 text-red-800">
        {message}
      </p>
      {detail && (
        <p className="mt-2 max-w-2xl text-xs font-mono leading-6 text-red-700">
          {detail}
        </p>
      )}
      {onAction && actionLabel && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex items-center justify-center rounded-sm border border-red-300 bg-white px-3 py-2 text-sm text-red-700 hover:border-red-400 hover:bg-red-50"
        >
          {actionLabel}
        </button>
      )}
    </section>
  );
}
